// Shareable typings and interfaces
export var StepDirectionTypes;

(function (StepDirectionTypes) {
  StepDirectionTypes["Top"] = "top";
  StepDirectionTypes["Right"] = "right";
  StepDirectionTypes["Bottom"] = "bottom";
  StepDirectionTypes["Left"] = "left";
})(StepDirectionTypes || (StepDirectionTypes = {}));